"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonGlobalParameterValue = void 0;
const vue_1 = require("vue");
const TranslateMixin_1 = require("./TranslateMixin");
const constants_1 = require("../constants");
exports.MoonGlobalParameterValue = vue_1.default.component('moon-global-parameter-value', {
    props: {
        moonData: {
            type: Object,
        },
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        isMax: function () {
            return this.moonData.colonyRate >= constants_1.MAXIMUM_COLONY_RATE &&
                this.moonData.miningRate >= constants_1.MAXIMUM_MINING_RATE &&
                this.moonData.logisticsRate >= constants_1.MAXIMUM_LOGISTICS_RATE;
        },
        colonyRate: function () {
            return this.moonData.colonyRate;
        },
        logisticsRate: function () {
            return this.moonData.logisticsRate;
        },
        miningRate: function () {
            return this.moonData.miningRate;
        },
    },
    template: `
<div>
  <div class="moon-tile"></div>
  <div>
    <div v-if="isMax()" class="preferences_global_params_value">
      <img src="/assets/misc/checkmark.png" class="preferences_checkmark" :alt="$t('Completed!')">
    </div>
    <div v-else class="moon_params_value">
      <span class="colony">{{colonyRate()}}</span>
      <span class="logistics">{{logisticsRate()}}</span>
      <span class="mining">{{miningRate()}}</span>
    </div>
  </div>
</div>
  `,
});
//# sourceMappingURL=MoonGlobalParameterValue.js.map